/* 工单信息接口 */

import ajax from '../ajax';
import axios from 'axios';
export default {
  // 获取我的工单列表信息
  myUserRepairOrderlist (params) {
    return ajax.get('/crmform/message/userRepairInterface/myUserRepairOrderlist.ht', params);
  },
  // 获取我的工单详情信息
  myUserRepairOrderDetails (params) {
    return ajax.get('/crmform/message/userRepairInterface/myUserRepairOrderDetails.ht', params);
  },
  // 获取我的工单回复信息
  myUserRepairReplyList (params) {
    return ajax.get('/crmform/message/userRepairInterface/myUserRepairReplyList.ht', params);
  },
  // 创建我的工单
  addUserRepairOrder (params) {
    const url = `/crmform/message/userRepairInterface/addUserRepairOrder.ht?tokenId=${localStorage.getItem('dl_tokenId_bl')}`;
    return ajax.postForm(url, params);
  },
  // 回复我的工单
  addUserReplyContent (params) {
    const url = `/crmform/message/userRepairInterface/addUserReplyContent.ht?tokenId=${localStorage.getItem('dl_tokenId_bl')}`;
    return ajax.postForm(url, params);
  },
  // 关闭我的工单
  downUserReplyOrder (params) {
    const url = `/crmform/message/userRepairInterface/downUserReplyOrder.ht?tokenId=${localStorage.getItem('dl_tokenId_bl')}`;
    return ajax.postForm(url, params);
  },
  // 获取角色申请列表
  getRoleRequestList (params) {
    return axios.get('/crmform/customer/crmCustomer/roleRequestList.ht', {
      headers: {
        tokenId: localStorage.getItem('dl_tokenId_bl')
      },
      params
    });
  },
  // 角色申请提交
  roleRequestSubmit (params) {
    return ajax.postForm('/crmform/customer/crmCustomer/roleRequestSubmit.ht', params);
  },
  // 获取角色申请详情
  getRoleRequestDetail (params) {
    return axios.get('/crmform/customer/crmCustomer/roleRequestDetail.ht', {
      headers: {
        tokenId: localStorage.getItem('dl_tokenId_bl')
      },
      params
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/personalCenter/work.js